import { render, staticRenderFns } from "./ad-actions.vue?vue&type=template&id=488de922&scoped=true"
import script from "./ad-actions.vue?vue&type=script&lang=js"
export * from "./ad-actions.vue?vue&type=script&lang=js"
import style0 from "./ad-actions.vue?vue&type=style&index=0&id=488de922&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488de922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3284107251/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('488de922')) {
      api.createRecord('488de922', component.options)
    } else {
      api.reload('488de922', component.options)
    }
    module.hot.accept("./ad-actions.vue?vue&type=template&id=488de922&scoped=true", function () {
      api.rerender('488de922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-actions.vue"
export default component.exports